import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaCheckCircle, FaStar } from 'react-icons/fa';

const features = [
  "Free professional website for all plans.",
  "Custom domain for  Enterprise plans.",
  "All reports printable and exportable.",
  "Support for ministry and mission structuring.",
  "Push notifications included by default.",
  "Church contact form bundled with FREE website",
  "Support online fundraising with FundReach",
  "Fund Accounting for your Church",
  "Worship planning",
  "Cradle register",
  "Home visit planning and tracking",
  "Loan Management",
  "Asset Tracking",
  "Budgets"
];

const AdditionalFeatures = () => {
  return (
    <Container fluid className="my-5">
      <Row className="justify-content-center">
        <Col md={10}>
          <Card className="p-4 shadow-sm border-0">
            <Card.Body>
              <h3 className="text-center mb-4" style={{ color: '#0f172a' }}>
                <FaStar className="me-2 text-warning" />
                Included Bonuses & Support
              </h3>
              <p className="text-center text-muted mb-5">
                We go the extra mile to support your ministry’s success.
              </p>
              <Row>
                {features.map((item, idx) => (
                  <Col key={idx} md={6} className="mb-3 d-flex align-items-start">
                    <FaCheckCircle className="text-success me-2 mt-1" />
                    <span>{item}</span>
                  </Col>
                ))}
              </Row>
              <div className="text-center mt-4">
                <p className="text-muted">
                  Need help? Our dedicated customer support is always here for you.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdditionalFeatures;
